export default "__VITE_ASSET__82ded305__"